import React from "react";

import { useCoverForContext } from "../../../provider/cover-for.provider";

function useFamilyModalHook() {
  const [selectedNumberOfParents, setSelectedNumberOfParents] = React.useState<
    number | null
  >(null);

  const {
    setSelectedAnswer,
    setIsFamilyModalOpen,
    setShouldTriggerToggleWrapper,
    isFamilyModalOpen,
  } = useCoverForContext();

  React.useEffect(() => {
    if (isFamilyModalOpen) {
      setSelectedNumberOfParents(null);
    }
  }, [isFamilyModalOpen]);

  function onSelectionChange(id: string) {
    const numberOfParents = parseInt(id, 10);
    setSelectedNumberOfParents(numberOfParents);
  }

  function onContinueClick() {
    if (selectedNumberOfParents === null) return;

    setSelectedAnswer(
      selectedNumberOfParents === 1 ? "SINGLE_PARENT_FAMILY" : "FAMILY"
    );
    setIsFamilyModalOpen(false);
    setShouldTriggerToggleWrapper(true);
    setSelectedNumberOfParents(null);
  }

  function onBackClick() {
    setIsFamilyModalOpen(false);
    setSelectedNumberOfParents(null);
  }

  return {
    selectedNumberOfParents,
    onSelectionChange,
    onContinueClick,
    onBackClick,
    isContinueDisabled: selectedNumberOfParents === null,
  };
}

export default useFamilyModalHook;
